import { toRem, toRems } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme, noHeading, step }) => ({
    [theme.breakpoints.up('md')]: {
        margin: toRem(20)
    },

    '& .CalculatorWrapper': {
        position: 'relative'
    },

    '& .progressBar': {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        width: '100%',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        gridGap: 2,
        borderRadius: '4px 4px 0 0',
        overflow: 'hidden',

        ...(step === 5 && {
            display: 'none'
        }),

        div: {
            height: 4,
            background: '#002131',
            opacity: 0.5,

            ...(step === 2 && {
                '&:nth-of-type(1)': {
                    background: theme.colors.goldDark,
                    opacity: 1
                }
            }),

            ...(step === 3 && {
                '&:nth-of-type(1)': {
                    background: theme.colors.goldDark,
                    opacity: 1
                },

                '&:nth-of-type(2)': {
                    background: theme.colors.goldDark,
                    opacity: 1
                }
            }),

            ...(step === 4 && {
                '&:nth-of-type(1)': {
                    background: theme.colors.goldDark,
                    opacity: 1
                },

                '&:nth-of-type(2)': {
                    background: theme.colors.goldDark,
                    opacity: 1
                },

                '&:nth-of-type(3)': {
                    background: theme.colors.goldDark,
                    opacity: 1
                }
            })
        }
    },

    '& .CalculatorContainer': {
        maxWidth: noHeading ? 1320 : 1440,
        margin: 'auto',
        padding: toRems([25, 20, 0, 20]),
        background: theme.colors.blueMidAlt,
        borderRadius: 4,

        [theme.breakpoints.up('md')]: {
            padding: toRems([50, 40, 0, 40])
        },

        [theme.breakpoints.up('lg')]: {
            padding: toRems([120, 160, 0, 160])
        },

        '& .Heading': {
            marginBottom: toRem(20),

            [theme.breakpoints.up('md')]: {
                marginBottom: toRem(45)
            },

            '& .Title': {
                color: theme.colors.goldDark,
                fontWeight: '500',
                fontSize: toRem(20),

                [theme.breakpoints.up('lg')]: {
                    fontSize: toRem(35)
                }
            },

            '& .Subtitle': {
                fontSize: toRem(14),
                [theme.breakpoints.up('lg')]: {
                    fontSize: toRem(16)
                }
            },
            [theme.breakpoints.up('lg')]: {
                marginBottom: toRem(25)
            }
        },

        '& .Content': {
            [theme.breakpoints.up('lg')]: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: noHeading ? 'flex-start' : 'center',
                justifyContent: 'space-between'
            },

            '& .Text': {
                fontSize: toRem(14),
                display: noHeading ? 'none' : 'block',

                [theme.breakpoints.up('lg')]: {
                    display: noHeading ? 'block' : 'block',
                    fontSize: toRem(20)
                }
            },
            '& .ServicesList': {
                display: 'flex',
                flexWrap: 'wrap',
                listStyle: 'none',
                marginTop: toRem(40),
                li: {
                    width: '100%',
                    [theme.breakpoints.up('lg')]: {
                        width: '50%'
                    }
                },
                [theme.breakpoints.up('lg')]: {
                    marginTop: 0,
                    width: '100%'
                }
            }
        },

        '& .checkbox-wrapper': {
            label: {
                paddingLeft: toRem(35)
            },

            '& .inputLabel': {
                paddingTop: toRem(10),
                fontSize: toRem(16),
                fontWeight: 500
            },

            '& .checkmark': {
                width: toRem(24),
                height: toRem(24),

                svg: {
                    zoom: 1.2
                }
            }
        },

        '& .CtaContainer': {
            marginLeft: 'calc(50% - 50vw)',
            marginRight: 'calc(50% - 50vw)'
        },

        '& .CtaContainerInner': {
            maxWidth: 1280,
            textAlign: 'center',
            marginTop: toRem(20),
            marginLeft: 'auto',
            marginRight: 'auto',
            padding: toRem(20),
            display: 'flex',
            justifyContent: 'space-between',
            borderTop: `1px solid ${theme.colors.blueDark}`,

            '& .secondary': {
                marginLeft: 'auto'
            },

            '&.ContinueToHomepage': {
                a: {
                    marginLeft: 0
                }
            },

            [theme.breakpoints.up('md')]: {
                marginTop: toRem(120),
                padding: toRems([20, 40])
            },

            [theme.breakpoints.up('lg')]: {
                padding: toRems([50, 160, 50, 160])
            },

            '& button': {
                maxHeight: toRem(42),

                [theme.breakpoints.up('lg')]: {
                    maxHeight: toRem(55)
                },

                '& > span': {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    '& svg': {
                        display: 'block',
                        flexShrink: 0,
                        marginLeft: toRem(5),
                        marginRight: toRem(5)
                    }
                }
            },

            '& .primary': {
                minWidth: 'initial',
                path: {
                    fill: 'transparent'
                },
                '&:hover': {
                    background: 'transparent',
                    color: '#E3B05F'
                }
            },

            '& a': {
                maxHeight: toRem(55),

                '& > span': {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    '& svg': {
                        display: 'block',
                        flexShrink: 0,
                        marginLeft: toRem(5)
                    }
                }
            }
        }
    },

    '& .boatTypeContainer': {
        marginBottom: toRem(30),
        display: 'grid',
        gridTemplateColumns: '1fr',
        gridRowGap: toRem(10),

        [theme.breakpoints.up('md')]: {
            marginBottom: toRem(50),
            gridTemplateColumns: '1fr 1fr 1fr',
            gridColumnGap: toRem(30)
        }
    },

    '& .boatType': {
        display: 'flex',
        alignItems: 'center',
        color: theme.colors.white,
        background: theme.colors.blueMid,
        height: 70,
        padding: '0 20px',
        borderRadius: 4,
        transition: 'all 0.5s ease',
        position: 'relative',
        // fontSize: toRem(12),
        border: '2px solid transparent',

        a: {
            color: theme.colors.blueMidAlt
        },

        [theme.breakpoints.up('md')]: {
            marginBottom: 20,
            height: 100
        },

        '.icon': {
            lineHeight: 0,
            zoom: 0.7,

            [theme.breakpoints.up('md')]: {
                zoom: 1
            }
        },

        '.content': {
            fontSize: toRem(14),
            marginLeft: 20,

            [theme.breakpoints.up('lg')]: {
                fontSize: toRem(16)
            },

            [theme.breakpoints.up('xl')]: {
                fontWeight: theme.typography.fontWeight.medium
            }
        }
    },

    '& .SelectYourServices': {
        marginTop: toRem(30),

        [theme.breakpoints.up('md')]: {
            marginTop: toRem(65)
        }
    },

    input: {
        flex: 1,
        minWidth: 0,
        fontSize: toRem(12),
        fontWeight: theme.typography.fontWeight.medium,
        border: '1px solid #D4A459',
        borderRadius: 5,
        background: '#D4A459',
        height: 60,
        padding: '0 20px',
        marginLeft: 20,
        outline: 'none',
        color: theme.colors.blueMidAlt,

        [theme.breakpoints.up('lg')]: {
            padding: '30px',
            height: '80px !important'
        },

        '&::placeholder': {
            fontSize: toRem(12),
            fontWeight: 500,
            color: theme.colors.blueMidAlt
        }
    },

    '.radio': {
        marginBottom: toRem(20),
        paddingLeft: 30,
        display: 'block',
        position: 'relative',
        cursor: 'pointer',
        fontSize: toRem(16),
        color: theme.colors.white,

        input: {
            display: 'none'
        },

        [theme.breakpoints.up('md')]: {
            display: 'inline',
            marginLeft: 60,
            marginBottom: 0,

            '&:first-of-type': {
                marginLeft: 0
            }
        },

        '&:before': {
            content: '""',
            display: 'block',
            width: 24,
            height: 24,
            borderRadius: '50%',
            border: `2px solid #E3B05F`,
            position: 'absolute',
            top: '50%',
            left: 10,
            transform: 'translate(-50%, -50%)'
        },

        '&:after': {
            content: '""',
            display: 'none',
            width: 11,
            height: 11,
            borderRadius: '50%',
            backgroundColor: '#E3B05F',
            position: 'absolute',
            top: '50%',
            left: 10,
            transform: 'translate(-50%, -50%)'
        },

        '&.checked': {
            '&:after': {
                display: 'block'
            }
        }
    },

    '.radio-image': {
        position: 'relative',
        cursor: 'pointer',
        fontSize: toRem(14),
        color: theme.colors.white,
        input: {
            display: 'none'
        },
        '&:hover': {
            '& .boatType': {
                border: '2px solid #D4A459'
            }
        },
        '&.checked': {
            '& .boatType': {
                border: '2px solid #E3B05F'
            }
        }
    },

    '& .CalculatorForm': {
        marginTop: toRem(40),

        [theme.breakpoints.up('md')]: {
            marginTop: toRem(80)
        },

        input: {
            margin: 0,
            padding: toRems([10, 25, 0, 25]),
            background: theme.colors.white,
            borderColor: 'transparent',
            height: '60px !important',
            color: theme.colors.blueMidAlt,
            fontSize: toRem(16),
            fontWeight: 600
        },

        label: {
            fontSize: toRem(13),
            color: '#00354F !important',

            '&.isActive': {
                top: 8,
                opacity: 0.5
            }
        }
    },

    '& .ThankYouBlock': {
        display: 'grid',
        gridTemplateColumns: '1fr',
        gridGap: toRem(20),
        alignItems: 'center',

        svg: {
            zoom: 0.6
        },

        [theme.breakpoints.up('md')]: {
            gridTemplateColumns: 'auto auto',
            gridGap: toRem(60),

            svg: {
                zoom: 1
            }
        }
    },

    '& button[disabled]': {
        opacity: 0.5,
        pointerEvents: 'none'
    }
})

export default style
